import { DialogService } from 'primeng/dynamicdialog';
import { ComingSoonDialog } from './coming-soon.dialog.ts';
import { firstValueFrom } from 'rxjs';

export const showComingSoonDialog =
  (dialogService: DialogService) => async (featureId: string, text: string) => {
    const ref = dialogService.open(...ComingSoonDialog(featureId, text));
    if (ref) {
      await firstValueFrom(ref.onClose);
    }
  };
